(function () {
  const block = {
    $blocks: document.querySelectorAll('.all_faqs'),
    init() {
      if (this.$blocks.length) {
        this.setUpListeners();
      }
    },

    setUpListeners() {
      this.$blocks
        .forEach($block => {
          const $loadMoreBtn = $block.querySelector('.grids > .load_more');

          if ($loadMoreBtn) {
            $loadMoreBtn.addEventListener('click', this.loadMore.bind(this));
          }

          $block
            .querySelectorAll('.togglers > .toggle')
            .forEach($toggler => $toggler.addEventListener(
              'click',
              ({currentTarget}) => {
                $block
                  .querySelectorAll('.togglers > .toggle')
                  .forEach($btn => $btn.classList.toggle('active'));

                $block
                  .querySelectorAll('.grids > .grid')
                  .forEach($grid => $grid.classList.toggle('active'));
              }
            ));

          $block
            .querySelectorAll('.answer > .yt_player')
            .forEach($yt_trigger => {
              $yt_trigger.addEventListener('click', ({currentTarget}) => {
                const $ytEl = document.createElement('DIV');
                $ytEl.setAttribute('id', 'player');
                $ytEl.dataset.youtubeId = this.getYouTubeVideoId(currentTarget.dataset.vurl);

                PubSub.publish('modal.open', $ytEl);
              });
            });
        });
    },

    getYouTubeVideoId(url) {
      const match = url.match(/(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([^&]+)/);
      return match ? match[1] : null;
    },

    loadMore({currentTarget}) {
      const $hiddenItems = currentTarget.closest('.grids').querySelectorAll('.grid.all > .hidden');

      if ($hiddenItems.length) {
        $hiddenItems
          .forEach(($item, id) => {
            if (id <= 5) {
              $item.classList.remove('hidden');
            }
          });
      }

      if (!$hiddenItems.length || $hiddenItems.length <= 6) {
        currentTarget.classList.remove('active');
      }
    }
  };

  block.init();
})();

